export class AppError extends Error {
  public name = 'AppError';
  constructor(msg: string,
              public code?: symbol,
              public payload?: any) {
    super(msg);
  }
}
